const COMMON_FACTORS = {
  CM_THRESHOLD: 152,
  PER_CM: 0.9,
  IN_THRESHOLD: 60,
  PER_INCH: 2.3,
};

const IBW_FACTORS = {
  Male: {
    BASE: 50,
    ...COMMON_FACTORS,
  },
  Female: {
    BASE: 45.5,
    ...COMMON_FACTORS,
  },
};

const UNIT_CONFIG = {
  cm: {
    thresholdKey: "CM_THRESHOLD",
    perUnitKey: "PER_CM",
  },
  inches: {
    thresholdKey: "IN_THRESHOLD",
    perUnitKey: "PER_INCH",
  },
};

export function calculateIdealBodyWeight({ sex, height, heightUnit = "cm", precision = 1 }) {
  if (sex !== 'Male' && sex !== 'Female') return null;
  const h = Number(height);
  if (!isFinite(h) || h <= 0) return null;
  const factors = IBW_FACTORS[sex];
  const unit = UNIT_CONFIG[heightUnit];
  if (!factors || !unit) return null;
  const threshold = factors[unit.thresholdKey];
  const perUnitFactor = factors[unit.perUnitKey];
  if (!isFinite(threshold) || !isFinite(perUnitFactor)) return null;
  const idealWeight =
    h <= threshold
      ? factors.BASE
      : factors.BASE + perUnitFactor * (h - threshold);  
  if (typeof precision === 'number' && precision >= 0) {
    const factor = Math.pow(10, precision);
    return Math.round(idealWeight * factor) / factor;
  }
  return idealWeight;
}
